var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemContentQueue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M21 13a1 1 0 0 1 .993.883L22 14v4a2 2 0 0 1-1.85 1.995L20 20H4a2 2 0 0 1-1.995-1.85L2 18v-4a1 1 0 0 1 1.993-.117L4 14v4h16v-4a1 1 0 0 1 1-1m-5 0a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2zm1-4a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm1-4a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z"
})));
export default SvgGemContentQueue;